import { DueDateOffsetField, PercentageField, SelectField } from 'form';
import { useTranslation } from 'i18n';
import { Grid, Typography } from 'ui';

import { getBuyerPaymentEventOptions, getPaymentMethodOptions, getSellerPaymentEventOptions } from '../../utils';

export const PaymentSection = () => {
  const { t } = useTranslation('orders');
  const paymentMethodOptions = getPaymentMethodOptions(t);
  const sellerPaymentEventOptions = getSellerPaymentEventOptions(t);
  const buyerPaymentEventOptions = getBuyerPaymentEventOptions(t);

  return (
    <>
      <Typography variant="h5">{t('profitabilityCalculator.payment.title')}</Typography>
      <Grid size={12}>
        <SelectField
          fullWidth
          label={t('profitabilityCalculator.payment.labels.purchaserPaymentMethod')}
          name="purchaser_payment_method"
          options={paymentMethodOptions}
        />
      </Grid>
      <Grid container spacing={3}>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <PercentageField
            label={t('profitabilityCalculator.payment.labels.sellerDepositPercentage')}
            name="seller_deposit_percentage"
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <SelectField
            fullWidth
            label={t('profitabilityCalculator.payment.labels.sellerPaymentEvent')}
            name="seller_payment_event"
            options={sellerPaymentEventOptions}
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <DueDateOffsetField
            required
            label={t('profitabilityCalculator.payment.labels.sellerDueDateOffset')}
            name="seller_due_date_offset"
            offsetFieldName="seller_due_date_offset_direction"
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <PercentageField
            label={t('profitabilityCalculator.payment.labels.purchaserDepositPercentage')}
            name="buyer_deposit_percentage"
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <SelectField
            fullWidth
            label={t('profitabilityCalculator.payment.labels.purchaserPaymentEvent')}
            name="buyer_payment_event"
            options={buyerPaymentEventOptions}
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <DueDateOffsetField
            label={t('profitabilityCalculator.payment.labels.purchaserDueDateOffset')}
            name="buyer_due_date_offset"
            offsetFieldName="buyer_due_date_offset_direction"
          />
        </Grid>
      </Grid>
    </>
  );
};
